import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import * as api from './api'

export default function* root() {
  yield takeLatestApiCall('WORKER_MISSING_PAY_FETCH', api.fetchMissingPay)
  yield takeLatestApiCall('WORKER_MISSING_PAY_DELETE', api.deleteMissingPay)
}
